const e = {
  4.5: "1.125rem",
  "size-25": "0.125rem",
  "size-50": "0.25rem",
  "size-75": "0.375rem",
  "size-100": "0.5rem",
  "size-125": "0.625rem",
  "size-150": "0.75rem",
  "size-175": "0.875rem",
  "size-200": "1rem",
  "size-250": "1.25rem",
  "size-300": "1.5rem",
  "size-350": "1.75rem",
  "size-400": "2rem",
  "size-450": "2.25rem",
  "size-500": "2.5rem",
  "size-600": "3rem",
  "size-650": "3.25rem",
  "size-700": "3.5rem",
  "size-800": "4rem",
  "size-900": "5rem",
  "size-1000": "6rem"
};
export {
  e as size
};
//# sourceMappingURL=size.es.js.map
